const state = {
  approveDialogShow: false,
  approvalNo: ''
}
const mutations = {
  APPROVE_DIALOG_SHOW: (state, approveDialogShow) => {
    state.approveDialogShow = ''
    state.approveDialogShow = approveDialogShow
  },
  APPROVE_DIALOG_SELECT_LINE: (state, approvalNo) => {
    state.approvalNo = approvalNo
  }
}
export default {
  state,
  mutations
}
